import type { RouteRecordRaw } from "vue-router";

export const miscRoutes: RouteRecordRaw[] = [
  {
    path: "/mimshop",
    name: "mimshop",
    // @ts-ignore TODO: convert view to typescript
    component: () => import("../../views/MimshopView.vue"),
    meta: { requiresAuth: true },
  },
];
